module.exports = __webpack_public_path__ + "media/images/products/tv-mobile-bdf01451d04187ede0ecd36aedd6b372.png";